import type {IDynamicImport} from '@/common/scripts/types/utils';

export const initFlatTabs = (wrapper: HTMLElement): void => {
    import(/* webpackChunkName: "tabs" */ '@/components/tabs')
        .then(({default: Tabs}: IDynamicImport) => {
            new Tabs().init({
                elem          : wrapper,
                tabsParent    : '.j-flat-views__tabs-nav',
                tabItem       : '.j-flat-views__tabs-item',
                contentsParent: '.j-flat-views__tabs-content',
                contentItem   : '.j-flat-views__tabs-pane'
            });
        });
};
